import type { ServerStats } from '../types';

export function formatHostRelay(serverStats: ServerStats | null | undefined): string {
  if (!serverStats) return '';

  const relayServer = serverStats.host_relay_server?.trim() || '';
  const activePath = serverStats.host_active_path?.trim() || '';
  const activeSession = serverStats.host_active_session?.trim() || '';

  if (!relayServer && !activePath && !activeSession) return '';

  const parts: string[] = [];
  if (relayServer) parts.push(relayServer);
  if (activePath) parts.push(`path=${activePath}`);
  if (activeSession) parts.push(`session=${activeSession}`);

  return parts.join(' ');
}
